var enLang = {
	"Đơn mới tạo": "Created",
	"Chờ thanh toán": "Waiting for payment",
	"Đã thanh toán": "Payment confirmed",
	"Đang xử lý": "Processing",
	"Đã hủy": "Cancelled",
	"Đã giao hàng": "Delivered",
	"Đã trả hàng": "Returned",
	"Đã hoàn tiền": "Refunded",
	"Chờ duyệt": "Waiting for approval",
	"Chờ xác nhận": "Waiting for confirmation",
	"Trả hàng": "Returning",
	"Đang giao hàng": "Delivering",
	"Hoàn thành": "Completed",
	"Chờ giao hàng": "Waiting for delivery",
	"Đang giao": "Delivering",
	"Đã giao": "Delivered",
	"Đã giao đại lý": "Delivered at agency",
	"Mới": "New",
	"Chờ hàng về": "Waiting for products",
	"Thanh toán trả chậm": "Deferred Payment",
	"Đã tiếp nhận": "Received",
	"Chờ đủ hàng": "Waiting for enough stock",
	"Chờ lấy hàng": "Waiting for products",
	"Đang lấy hàng": "Picking",
	"Đã lấy hàng": "Picked",
	"Đóng gói xong": "Packed",
	"Giao một phần": "Partial delivered"
};

export { enLang as default };
